import { getDictPhrase } from "../../../common";
import { getEachWayBetStakeInfo } from "../../bet";
export const getBetStakeProps = (bet, state) => {
    const props = {
        phrase: getDictPhrase(state.dict, "Stake"),
        amount: state.formatCurrency(bet.totalStake)
    };
    if (bet.isEachWay) {
        props.amount = `${props.amount} ${getEachWayBetStakeInfo(bet, state)}`;
    }
    return props;
};
//# sourceMappingURL=getBetStakeProps.js.map